import { CustomerType, PaymentCategory, SchedulingFilter, DbRef, Role, BillingOption, TrackingEvent, FulfillmentIntegrationName, FulfillmentIntegrationType, GenericOfficeIDs, DraftWaypointStatus, InstructionType, YesNoOptionLabel, cancerguardSupportedProducts, CANCERGUARD_SUPPORT_PHONE_NUMBER, EXAS_SUPPORT_PHONE_NUMBER, DUMMY_PLACE_GROUP_ID } from '@caresend/types';
import { initLocationObject, initTimeZoneDate, nullishFilter, getUnknownErrorMessage, getRequiredSuppliesFromInstructions, getNurseHasSupplies, isNullish, getPatientsFromProceduresData, draftWaypointDataToUnencryptedDraftWaypoint, proceduresDataToBookings, proceduresDataToProcedures, proceduresDataToSupplyInstructionConfigOptions, getPrescriberDataFromDraftWaypointData, getWaypointFromWaypointData, getWaypointActionsFromWaypointActionsData, errorSuffix, getOfficePath, initPatientInitiatedDraftOrder, initDraftWaypoint, keyValueArrayToObj, hasStatus, getServiceRegionFromLocation, getServiceRegionGroupFromLocation, getEligibleTimeSlots, generateID, arrayToObj, objectFilter, SECOND } from '@caresend/utils';
import update from 'immutability-helper';
import cloneDeep from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';
import { computed } from 'vue';
import { useItineraryGeoSearch } from '../../../components/specific/portal/components/useItineraryGeoSearch.js';
import 'firebase/auth';
import { chargeOfficeForVisitRequest, scheduleDraftWaypointVisitRequest, getDraftWaypointDataRequest, getSchedulingOptionsRequest, handlePaymentIntentSucceededRequest, createPaymentIntentRequest, trackSchedulingAttemptRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import { isProd } from '../../../database/firebaseConfig/init.js';
import { getValueOnce } from '../../../database/firebaseConfig/methods.js';
import { reportException } from '../../../functions/sentry.js';
import { toastErrorAndReport, toastSuccess, toastError } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import { trackEvent } from '../../../functions/tracking/tracking.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { keepParams, keepQuery } from '../../../router/helpers/builders.js';
import { getRoute, getRouterRuntimeHelpers, getRouter } from '../../../router/helpers/initRouter.js';
import { buildMaybePartnerRouteWithCurrentRoute } from '../../../router/helpers/router.js';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import { draftWaypointDetailsRoute, homeRoute } from '../../../router/routes/locations.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import { SchedulingFlowRouteName } from '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/visitsPage/routes.js';
import { isPatientUser, getUserRole, customCommit, isDashboardUser } from '../../helpers.js';
import { initExtendedModule } from '../helpers.js';
import { saveOrderAsDraft } from '../orderFlow/helpers.js';
import { isSchedulingDryRun, getUpdatedTimeSlot, getAreAllSupplyInstructionsPresentForDraftWaypoint, getPatientPays, getOfficeFromProceduresData, getStaffingInfoPerTimeSlot } from './helpers/index.js';
import { setSchedulingFlowLocalDraftWaypointFinalized, setSchedulingFlowLocalOldDraftWaypointCanceled } from './helpers/local.js';
import { setDataForRescheduling, getReschedulableProcedureData, getCanceledProceduresBeingRescheduled } from './helpers/rescheduling.js';
import { InitSchedulingFlowErrorMessage } from './model.js';
import { getSchedulingFlowHelpers } from './schedulingFlowSteps/steps.js';
import { getIsDebugMode, getIsFulfillmentIntegrationEnabled } from '../variables/helpers.js';
import { useDraftWaypointsStore } from '../../pinia/draftWaypoints/index.js';

/* eslint sort-keys-fix/sort-keys-fix: "error" */
const initialLocalState = (
/**
 * Undefined for the module init, but must be passed any time the scheduling
 * flow component mounts.
 */
draftWaypointID) => {
    const flowDataLoadingInit = draftWaypointID ? { [draftWaypointID]: false } : {};
    return {
        flowDataIsReady: flowDataLoadingInit,
        flowLoadingCompleted: flowDataLoadingInit,
        flowLoadingError: null,
        isBrickAndMortarVisit: false,
        isBrickAndMortarVisitEligible: false,
        loading: {},
        locallyFinalized: false,
        nextButtonLoading: false,
        proceduresIneligibleForRescheduling: [],
    };
};
const initPatientInitiatedUserProfile = () => ({
    dateOfBirth: null,
    firstName: '',
    gender: '',
    lastName: '',
});
const initState = (
/**
 * Undefined for the module init, but must be passed any time the scheduling
 * flow component mounts.
 */
draftWaypointID) => ({
    adminMode: false,
    adminModeAllStaffingOffices: undefined,
    adminModeOfficeFilters: undefined,
    adminModeShowAllTimeSlots: true,
    adminModeStaffingInfoPerTimeSlot: {},
    availableTimeSlots: {},
    bookings: {},
    draftBookings: {},
    draftProcedures: {},
    draftWaypoint: undefined,
    isNurseRescheduling: false,
    isPatientInitiated: false,
    labOptions: {},
    localState: initialLocalState(draftWaypointID),
    // Currently not supporting reactivity if initialized as undefined due to the
    // way mutations are written.
    location: initLocationObject(),
    patientInitiatedUserProfile: initPatientInitiatedUserProfile(),
    patientPays: false,
    patientSchedules: false,
    patients: {},
    paymentFormInitError: false,
    paymentIntentInfo: undefined,
    placeGroups: {},
    practiceInfo: {
        city: '',
        doctorName: '',
    },
    prescriber: undefined,
    primaryContact: undefined,
    procedures: {},
    schedulingConfig: undefined,
    schedulingFilters: undefined,
    selectedDrawPlaceID: undefined,
    selectedTimeSlot: undefined,
    serviceRegion: undefined,
    serviceRegionGroup: undefined,
    shiftCancelReason: undefined,
    supplyInstructionConfigOptions: {},
    supplyTransfers: {},
    timeSlotsLastFetchedAt: null,
    visitPaidOffline: false,
    waypoint: undefined,
    waypointActions: {},
});
const schedulingFlowState = initState();
/**
 * Sets location both on state.location and state.draftWaypoint.location
 * if it exists.
 */
const setLocation = (state, locationObj) => {
    state.location = locationObj;
    if (!state.draftWaypoint)
        return;
    state.draftWaypoint = update(state.draftWaypoint, { location: { $set: locationObj } });
};
/**
 * Avoid saving `undefined` values to the state as they cannot be written to
 * Firebase.
 *
 * TODO: Move to utils, avoid type casting if possible.
 */
const getSetOrUnsetSpec = (key, value) => {
    if (value)
        return { [key]: { $set: value } };
    return { $unset: [key] };
};
const schedulingFlowMutations = {
    'schedulingFlow/RESET_DATE_RANGE_ON_DRAFT_WAYPOINT': (state) => {
        if (!state.draftWaypoint)
            return;
        state.draftWaypoint = update(state.draftWaypoint, {
            $unset: ['dateRange', 'timeRange'],
        });
    },
    'schedulingFlow/RESET_MODULE': (state, draftWaypointID) => {
        Object.assign(state, initState(draftWaypointID));
    },
    'schedulingFlow/RESET_PAYMENT_INTENT_INFO': (state) => {
        state.paymentIntentInfo = undefined;
    },
    'schedulingFlow/RESET_SCHEDULING_OPTIONS': (state) => {
        state.availableTimeSlots = {};
        state.labOptions = {};
        state.timeSlotsLastFetchedAt = null;
        state.selectedDrawPlaceID = undefined;
    },
    'schedulingFlow/RESET_TIME_RANGE_ON_DRAFT_WAYPOINT': (state) => {
        if (!state.draftWaypoint)
            return;
        state.draftWaypoint = update(state.draftWaypoint, {
            $unset: ['timeRange'],
        });
    },
    'schedulingFlow/SET_ADDITIONAL_INSTRUCTIONS': (state, input) => {
        const newLocation = update(state.location, getSetOrUnsetSpec('additionalInstructions', input));
        setLocation(state, newLocation);
    },
    'schedulingFlow/SET_ADMIN_MODE': (state, isAdminMode) => {
        state.adminMode = isAdminMode;
        localStorage.setItem('schedulingFlowAdminMode', String(isAdminMode));
    },
    'schedulingFlow/SET_ADMIN_MODE_ALL_STAFFING_OFFICES': (state, staffingOfficeNames) => {
        state.adminModeAllStaffingOffices = Object.entries(staffingOfficeNames).map(([id, name]) => ({ id, name }));
    },
    'schedulingFlow/SET_ADMIN_MODE_OFFICE_FILTERS': (state, officeFilters) => {
        var _a;
        state.adminModeOfficeFilters = officeFilters !== null && officeFilters !== void 0 ? officeFilters : state.adminModeAllStaffingOffices;
        state.adminModeShowAllTimeSlots = !officeFilters
            || !!((_a = state.adminModeAllStaffingOffices) === null || _a === void 0 ? void 0 : _a.every((office) => officeFilters.some((filter) => filter.id === office.id)));
    },
    'schedulingFlow/SET_ADMIN_MODE_STAFFING_INFO_PER_TIME_SLOT': (state, staffingInfoPerTimeSlot) => {
        state.adminModeStaffingInfoPerTimeSlot = staffingInfoPerTimeSlot;
    },
    'schedulingFlow/SET_APT_NUMBER': (state, input) => {
        const newLocation = update(state.location, getSetOrUnsetSpec('aptNumber', input));
        setLocation(state, newLocation);
    },
    'schedulingFlow/SET_AVAILABLE_TIME_SLOTS': (state, timeSlots) => {
        state.availableTimeSlots = timeSlots;
    },
    'schedulingFlow/SET_BOOKINGS': (state, bookings) => {
        state.bookings = bookings;
    },
    'schedulingFlow/SET_CANCELED_PROCEDURES_BEING_RESCHEDULED': (state, canceledProceduresBeingRescheduled) => {
        state.canceledProceduresBeingRescheduled = canceledProceduresBeingRescheduled;
    },
    'schedulingFlow/SET_DATE_OPTIONS': (state, dateOptions) => {
        if (!state.draftWaypoint)
            return;
        state.draftWaypoint.dateOptions = dateOptions;
    },
    'schedulingFlow/SET_DATE_RANGE_ON_DRAFT_WAYPOINT': (state, dateRange) => {
        if (!state.draftWaypoint)
            return;
        state.draftWaypoint = update(state.draftWaypoint, { dateRange: { $set: dateRange } });
    },
    'schedulingFlow/SET_DRAFT_BOOKINGS': (state, draftBookings) => {
        state.draftBookings = draftBookings;
    },
    'schedulingFlow/SET_DRAFT_PROCEDURES': (state, draftProcedures) => {
        state.draftProcedures = draftProcedures;
    },
    'schedulingFlow/SET_DRAFT_WAYPOINT': (state, draftWaypoint) => {
        state.draftWaypoint = draftWaypoint;
    },
    'schedulingFlow/SET_DRAFT_WAYPOINT_SUPPLY_STRATEGY': (state, strategy) => {
        if (!state.draftWaypoint)
            throw Error('Missing draft waypoint');
        state.draftWaypoint = update(state.draftWaypoint, {
            supplyStrategy: { $set: strategy },
        });
    },
    'schedulingFlow/SET_FINALIZED_BY_USER_ID': (state, userID) => {
        if (!state.draftWaypoint) {
            throw Error('Missing Draft Waypoint when setting the finalizing user');
        }
        state.draftWaypoint = update(state.draftWaypoint, {
            finalizedByUserID: { $set: userID },
        });
    },
    'schedulingFlow/SET_FINALIZED_DATE': (state, finalizedDate) => {
        if (!state.draftWaypoint)
            throw Error('Missing Draft Waypoint when updating finalized date');
        state.draftWaypoint = update(state.draftWaypoint, {
            finalizedDate: { $set: finalizedDate },
        });
    },
    'schedulingFlow/SET_FINALIZED_MANUALLY': (state, finalizedManually) => {
        if (!state.draftWaypoint)
            throw Error('Missing Draft Waypoint when updating finalization method');
        state.draftWaypoint = update(state.draftWaypoint, {
            finalizedManually: { $set: finalizedManually },
        });
    },
    'schedulingFlow/SET_FLEXIBLE_ON_DRAFT_WAYPOINT': (state, flexibleScheduling) => {
        if (!state.draftWaypoint)
            return;
        state.draftWaypoint = update(state.draftWaypoint, { flexibleScheduling: { $set: flexibleScheduling } });
    },
    'schedulingFlow/SET_FLOW_DATA_IS_READY': (state, { draftWaypointID, ready }) => {
        state.localState.flowDataIsReady = update(state.localState.flowDataIsReady, { [draftWaypointID]: { $set: ready } });
    },
    'schedulingFlow/SET_FLOW_LOADING_COMPLETED': (state, { draftWaypointID, completed }) => {
        if (!completed) {
            state.localState.flowDataIsReady = update(state.localState.flowDataIsReady, { [draftWaypointID]: { $set: false } });
        }
        state.localState.flowLoadingCompleted = update(state.localState.flowLoadingCompleted, { [draftWaypointID]: { $set: completed } });
    },
    'schedulingFlow/SET_FLOW_LOADING_ERROR': (state, message) => {
        state.localState.flowLoadingError = message;
    },
    'schedulingFlow/SET_IS_BRICK_AND_MORTAR': (state, value) => {
        state.localState.isBrickAndMortarVisit = value;
    },
    'schedulingFlow/SET_IS_BRICK_AND_MORTAR_ELIGIBLE': (state, value) => {
        state.localState.isBrickAndMortarVisitEligible = value;
    },
    'schedulingFlow/SET_IS_PATIENT_INITIATED': (state, isPatientInitiated) => {
        state.isPatientInitiated = isPatientInitiated;
    },
    'schedulingFlow/SET_IS_PATIENT_INITIATED_USER_PROFILE': (state, patientInitiatedUserProfile) => {
        state.patientInitiatedUserProfile = patientInitiatedUserProfile;
    },
    'schedulingFlow/SET_IS_PAYMENT_DISABLED': (state, isPaymentDisabled) => {
        state.isPaymentDisabled = isPaymentDisabled;
    },
    'schedulingFlow/SET_IS_RESCHEDULING': (state, value) => {
        state.localState.isRescheduling = value;
    },
    'schedulingFlow/SET_LAB_OPTIONS': (state, labOptions) => {
        state.labOptions = labOptions;
    },
    'schedulingFlow/SET_LOADING': (state, { draftWaypointID, loadingData }) => {
        state.localState = update(state.localState, { loading: {
                [draftWaypointID]: {
                    $set: loadingData,
                },
            } });
    },
    'schedulingFlow/SET_LOCATION': (state, locationObj) => {
        setLocation(state, locationObj);
    },
    'schedulingFlow/SET_LOCATION_FORMATTED_ADDRESS': (state, address) => {
        if (!state.location)
            return;
        state.location = update(state.location, { formattedAddress: { $set: address } });
    },
    'schedulingFlow/SET_NEW_DRAFT_WAYPOINT_ID': (state, newDraftWaypointID) => {
        state.localState.newDraftWaypointID = newDraftWaypointID;
    },
    'schedulingFlow/SET_NEXT_BUTTON_LOADING': (state, isLoading) => {
        state.localState.nextButtonLoading = isLoading;
    },
    'schedulingFlow/SET_NURSE_RESCHEDULING_DETAILS': (state, nurseReschedulingDetails) => {
        state.isNurseRescheduling = true;
        state.shiftID = nurseReschedulingDetails.shiftID;
        state.shiftCancelReason = nurseReschedulingDetails.shiftCancelReason;
    },
    'schedulingFlow/SET_OFFLINE_PAYMENT_AMOUNT': (state, amount) => {
        if (!amount) {
            /** unset offlinePayment object */
            state.draftWaypoint = update(state.draftWaypoint, {
                $unset: ['offlinePayment'],
            });
            return;
        }
        state.draftWaypoint = update(state.draftWaypoint, {
            offlinePayment: { $set: { amount: amount * 100 } },
        });
    },
    'schedulingFlow/SET_OLD_DRAFT_WAYPOINT': (state, oldDraftWaypoint) => {
        state.localState.oldDraftWaypoint = oldDraftWaypoint;
    },
    'schedulingFlow/SET_PATIENT': (state, patient) => {
        state.patients = update(state.patients, { [patient.id]: { $set: patient } });
    },
    'schedulingFlow/SET_PATIENTS': (state, patients) => {
        state.patients = patients;
    },
    'schedulingFlow/SET_PATIENT_PAYS': (state, patientPays) => {
        state.patientPays = patientPays;
    },
    'schedulingFlow/SET_PATIENT_SCHEDULES': (state, patientSchedules) => {
        state.patientSchedules = patientSchedules;
    },
    'schedulingFlow/SET_PAYMENT_FORM_INIT_ERROR': (state, bool) => {
        state.paymentFormInitError = bool;
    },
    'schedulingFlow/SET_PAYMENT_INTENT_INFO': (state, newInfo) => {
        state.paymentIntentInfo = newInfo;
    },
    'schedulingFlow/SET_PHONE_NUMBER_IS_VALID': (state, phoneNumberIsValid) => {
        state.localState.phoneNumberIsValid = phoneNumberIsValid;
    },
    'schedulingFlow/SET_PLACE_ACCOUNTS': (state, placeAccounts) => {
        state.placeAccounts = placeAccounts;
    },
    'schedulingFlow/SET_PLACE_GROUPS': (state, placeGroups) => {
        state.placeGroups = placeGroups;
    },
    'schedulingFlow/SET_PRACTICE_INFO': (state, practiceInfo) => {
        state.practiceInfo = update(state.practiceInfo, { $set: practiceInfo });
    },
    'schedulingFlow/SET_PRESCRIBER': (state, prescriber) => {
        state.prescriber = prescriber;
    },
    'schedulingFlow/SET_PRICING_INFO': (state, pricingInfo) => {
        if (!state.draftWaypoint)
            throw Error('Missing Draft Waypoint when updating pricing info');
        state.draftWaypoint = update(state.draftWaypoint, {
            pricingInfo: { $set: pricingInfo },
        });
    },
    'schedulingFlow/SET_PRIMARY_CONTACT': (state, contact) => {
        state.primaryContact = contact;
    },
    'schedulingFlow/SET_PRIMARY_CONTACT_NAME': (state, name) => {
        state.primaryContact = update(state.primaryContact, {
            name: { $set: name },
        });
    },
    'schedulingFlow/SET_PRIMARY_CONTACT_PHONE': (state, phone) => {
        state.primaryContact = update(state.primaryContact, {
            phone: { $set: phone },
        });
    },
    'schedulingFlow/SET_PROCEDURES': (state, procedures) => {
        state.procedures = procedures;
    },
    'schedulingFlow/SET_PROCEDURES_INELIGIBLE_FOR_RESCHEDULING': (state, proceduresIneligibleForRescheduling) => {
        state.localState.proceduresIneligibleForRescheduling = proceduresIneligibleForRescheduling;
    },
    'schedulingFlow/SET_SCHEDULING_CONFIG': (state, schedulingConfig) => {
        state.schedulingConfig = schedulingConfig;
    },
    'schedulingFlow/SET_SCHEDULING_FILTERS': (state, schedulingFilters) => {
        state.schedulingFilters = schedulingFilters;
    },
    'schedulingFlow/SET_SELECTED_DRAW_PLACE_ID': (state, placeID) => {
        state.selectedDrawPlaceID = placeID;
    },
    'schedulingFlow/SET_SELECTED_TIME_SLOT': (state, timeSlot) => {
        var _a, _b, _c;
        state.selectedTimeSlot = timeSlot;
        const { isPaymentDisabled } = state;
        const price = (_a = timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.priceInfo) === null || _a === void 0 ? void 0 : _a.visitPrice;
        if (!(timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.startTime)
            || (!isPaymentDisabled && (!price || price === 0)))
            return;
        const finalizedDate = {
            date: initTimeZoneDate((_c = (_b = state.draftWaypoint) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.timeZone, timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.startTime),
            price: isPaymentDisabled ? 0 : price !== null && price !== void 0 ? price : 0,
        };
        state.draftWaypoint = update(state.draftWaypoint, {
            finalizedDate: { $set: finalizedDate },
            packingDeadline: { $set: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.packingDeadline },
        });
    },
    'schedulingFlow/SET_SERVICE_REGION': (state, serviceRegion) => {
        if (!serviceRegion)
            return;
        state.serviceRegion = serviceRegion;
    },
    'schedulingFlow/SET_SERVICE_REGION_GROUP': (state, serviceRegionGroup) => {
        if (!serviceRegionGroup)
            return;
        state.serviceRegionGroup = serviceRegionGroup;
    },
    'schedulingFlow/SET_SUPPLY_INSTRUCTION_CONFIG_OPTIONS': (state, supplyInstructionConfigOptions) => {
        state.supplyInstructionConfigOptions = supplyInstructionConfigOptions;
    },
    'schedulingFlow/SET_SUPPLY_TRANSFERS': (state, supplyTransfers) => {
        state.supplyTransfers = supplyTransfers;
    },
    'schedulingFlow/SET_TIME_RANGE_ON_DRAFT_WAYPOINT': (state, { timeRange, set }) => {
        var _a;
        if (!state.draftWaypoint)
            return;
        if (!state.draftWaypoint.timeRange) {
            // Initialize timeRange as an empty array if it's undefined
            state.draftWaypoint = update(state.draftWaypoint, { timeRange: {
                    $set: [],
                } });
        }
        if (set) {
            state.draftWaypoint = update(state.draftWaypoint, { timeRange: {
                    $push: [timeRange],
                } });
        }
        else {
            const currentIndex = (_a = state.draftWaypoint.timeRange) === null || _a === void 0 ? void 0 : _a.findIndex((range) => isEqual(range, timeRange));
            if (currentIndex) {
                state.draftWaypoint = update(state.draftWaypoint, { timeRange: {
                        $splice: [[currentIndex, 1]],
                    } });
            }
            else {
                const newRange = cloneDeep(state.draftWaypoint.timeRange);
                if (!newRange)
                    return;
                delete newRange[0];
                state.draftWaypoint = update(state.draftWaypoint, { timeRange: {
                        $set: newRange.filter(nullishFilter),
                    } });
            }
        }
    },
    'schedulingFlow/SET_TIME_SLOTS_LAST_FETCHED_AT': (state, timeSlotsLastFetchedAt) => {
        state.timeSlotsLastFetchedAt = timeSlotsLastFetchedAt;
    },
    'schedulingFlow/SET_VISIT_LOCALLY_FINALIZED': (state, locallyFinalized) => {
        state.localState.locallyFinalized = locallyFinalized;
    },
    'schedulingFlow/SET_VISIT_PAID_OFFLINE': (state, visitPaidOffline) => {
        state.visitPaidOffline = visitPaidOffline;
        state.draftWaypoint = update(state.draftWaypoint, {
            offlinePayment: { $set: {} },
        });
    },
    'schedulingFlow/SET_WAYPOINT': (state, waypoint) => {
        state.waypoint = waypoint;
    },
    'schedulingFlow/SET_WAYPOINT_ACTIONS': (state, waypointActions) => {
        state.waypointActions = waypointActions;
    },
    'schedulingFlow/UPDATE_DRAFT_WAYPOINT': (state, draftWaypointUpdate) => {
        state.draftWaypoint = update(state.draftWaypoint, {
            $merge: draftWaypointUpdate,
        });
    },
};
const schedulingFlowActions = {
    // TODO: consider moving to cloud `confirmVisit` function.
    'schedulingFlow/chargeOfficeForVisit': async ({ commit, state }) => {
        const { draftWaypoint, selectedTimeSlot, } = state;
        if (!draftWaypoint
            || !draftWaypoint.officeID
            || !(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.priceInfo))
            throw Error('Missing visit information when processing payment.');
        try {
            const requestData = {
                customerType: CustomerType.OFFICE,
                draftWaypointID: draftWaypoint.id,
                idForPayment: draftWaypoint.officeID,
                paymentCategory: PaymentCategory.VISIT,
                price: selectedTimeSlot.priceInfo.visitPrice,
            };
            const error = await chargeOfficeForVisitRequest(requestData);
            if (error)
                return error;
            commit('schedulingFlow/SET_PRICING_INFO', selectedTimeSlot.priceInfo);
        }
        catch (error) {
            const errorMessage = getUnknownErrorMessage(error);
            toastErrorAndReport(`There was a problem scheduling the visit. ${errorMessage}`);
        }
    },
    'schedulingFlow/confirmBrickAndMortarVisit': async ({ commit, state, rootState, dispatch }) => {
        var _a, _b;
        if (!rootState.auth.user)
            throw Error('User needs to be logged in.');
        // `draftWaypoint` must not be destructured from state, as it is mutated
        // below.
        const { canceledProceduresBeingRescheduled, isPatientInitiated, primaryContact, selectedDrawPlaceID, } = state;
        const oldDraftWaypointID = (_a = state.localState.oldDraftWaypoint) === null || _a === void 0 ? void 0 : _a.id;
        const isMissingRequiredOldDraftWaypoint = state.localState.isRescheduling && !oldDraftWaypointID;
        if (!state.draftWaypoint
            || !selectedDrawPlaceID
            || !state.draftWaypoint.location
            || !primaryContact
            || isMissingRequiredOldDraftWaypoint)
            throw Error('Missing waypoint information.');
        if (isPatientInitiated) {
            await dispatch('schedulingFlow/savePatientInitiatedOrder');
        }
        if (!state.draftWaypoint.finalizedByUserID) {
            commit('schedulingFlow/SET_FINALIZED_BY_USER_ID', (_b = rootState.auth.user) === null || _b === void 0 ? void 0 : _b.id);
        }
        commit('schedulingFlow/SET_FINALIZED_MANUALLY', true);
        const requestData = {
            draftWaypoint: state.draftWaypoint,
            isDryRun: isSchedulingDryRun(state.draftWaypoint),
            oldDraftWaypointID,
            primaryContact,
            proceduresToRestore: canceledProceduresBeingRescheduled,
            selectedDrawPlaceID,
        };
        const { dryRunUpdates } = await scheduleDraftWaypointVisitRequest(requestData);
        if (dryRunUpdates)
            console.info('Visit scheduled (dry run)', dryRunUpdates);
    },
    'schedulingFlow/confirmMobileVisit': async ({ commit, state, rootState, dispatch }) => {
        var _a, _b, _c, _d;
        if (!rootState.auth.user)
            throw Error('User needs to be logged in.');
        // `draftWaypoint` must not be destructured from state, as it is mutated
        // below.
        const { canceledProceduresBeingRescheduled, isNurseRescheduling, isPatientInitiated, primaryContact, schedulingConfig, selectedTimeSlot, shiftCancelReason, shiftID, schedulingFilters, } = state;
        if (!selectedTimeSlot)
            throw Error('Missing waypoint information.');
        const updatedTimeSlot = getUpdatedTimeSlot(selectedTimeSlot);
        const { availableNurses, bestRankedNurseID, samplesDeliveryTypes, priceInfo, } = updatedTimeSlot !== null && updatedTimeSlot !== void 0 ? updatedTimeSlot : {};
        const bestNurse = bestRankedNurseID ? availableNurses === null || availableNurses === void 0 ? void 0 : availableNurses[bestRankedNurseID] : undefined;
        const { timeSlotsLastFetchedAt } = state;
        const secondsSinceTimeSlotRefresh = timeSlotsLastFetchedAt
            ? (Date.now() - timeSlotsLastFetchedAt) / SECOND
            : undefined;
        const isMissingRequiredNurse = !bestNurse && (schedulingFilters === null || schedulingFilters === void 0 ? void 0 : schedulingFilters.includes(SchedulingFilter.NURSE));
        const isMissingRequiredSamplesDeliveryType = (schedulingFilters === null || schedulingFilters === void 0 ? void 0 : schedulingFilters.includes(SchedulingFilter.DROP_OFF))
            && !samplesDeliveryTypes;
        const requiredSupplies = getRequiredSuppliesFromInstructions(state.supplyInstructionConfigOptions);
        const nurseHasSupplies = bestNurse ? getNurseHasSupplies(bestNurse, requiredSupplies) : false;
        const isMissingRequiredPackingDeadline = (schedulingFilters === null || schedulingFilters === void 0 ? void 0 : schedulingFilters.includes(SchedulingFilter.SUPPLIES_SHIPPED_BY_CARESEND))
            && !nurseHasSupplies
            && !((_a = state.draftWaypoint) === null || _a === void 0 ? void 0 : _a.packingDeadline);
        const isMissingRequiredVisitPrice = !state.isPaymentDisabled
            && isNullish(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.visitPrice);
        const oldDraftWaypointID = (_b = state.localState.oldDraftWaypoint) === null || _b === void 0 ? void 0 : _b.id;
        const isMissingRequiredOldDraftWaypoint = state.localState.isRescheduling && !oldDraftWaypointID;
        if (!state.draftWaypoint
            || !state.draftWaypoint.location
            || !schedulingFilters
            || !primaryContact
            || isNullish(schedulingConfig)
            || isNullish(secondsSinceTimeSlotRefresh)
            || isMissingRequiredNurse
            || isMissingRequiredPackingDeadline
            || isMissingRequiredOldDraftWaypoint
            || isMissingRequiredSamplesDeliveryType
            || isMissingRequiredVisitPrice
            || (isNurseRescheduling && (!shiftID || !shiftCancelReason)))
            throw Error('Missing waypoint information.');
        if (isPatientInitiated) {
            await dispatch('schedulingFlow/savePatientInitiatedOrder');
        }
        if (!state.draftWaypoint.finalizedByUserID || isNurseRescheduling) {
            commit('schedulingFlow/SET_FINALIZED_BY_USER_ID', (_c = rootState.auth.user) === null || _c === void 0 ? void 0 : _c.id);
        }
        commit('schedulingFlow/SET_FINALIZED_MANUALLY', true);
        if (!state.isPaymentDisabled) {
            if (!selectedTimeSlot.priceInfo)
                throw Error('Missing price info');
            commit('schedulingFlow/SET_PRICING_INFO', selectedTimeSlot.priceInfo);
        }
        const isDryRun = isSchedulingDryRun(state.draftWaypoint);
        const cancelShiftAsNurseRequest = isNurseRescheduling && shiftID && shiftCancelReason
            ? {
                cancelReason: shiftCancelReason,
                isDryRun,
                isRescheduling: true,
                procedureIDs: Object.keys(state.draftWaypoint.procedures),
                shiftID,
            }
            : undefined;
        const requestData = {
            cancelShiftAsNurseRequest,
            draftWaypoint: state.draftWaypoint,
            isDryRun,
            isPendingNurseAllowed: (_d = schedulingConfig.baseScheduling) === null || _d === void 0 ? void 0 : _d.enablePendingNurseID,
            oldDraftWaypointID,
            primaryContact,
            proceduresToRestore: canceledProceduresBeingRescheduled,
            schedulingFilters,
            secondsSinceTimeSlotRefresh,
            selectedTimeSlot: updatedTimeSlot,
        };
        const { dryRunUpdates } = await scheduleDraftWaypointVisitRequest(requestData);
        if (dryRunUpdates)
            console.info('Visit scheduled (dry run)', dryRunUpdates);
        if (shiftID) {
            const { nurseJustDeclinedOrCanceledShiftIds } = useItineraryGeoSearch();
            nurseJustDeclinedOrCanceledShiftIds.add(shiftID);
        }
    },
    'schedulingFlow/confirmVisit': async ({ dispatch, getters, state }) => {
        const { draftWaypoint, isNurseRescheduling, localState, primaryContact } = state;
        const { isRescheduling, isBrickAndMortarVisit } = localState;
        if (!draftWaypoint) {
            throw Error('Missing draft waypoint when rescheduling');
        }
        if (!primaryContact) {
            throw Error('Please add a point of contact.');
        }
        const draftWaypointStore = useDraftWaypointsStore();
        const confirmVisitAction = isBrickAndMortarVisit
            ? 'schedulingFlow/confirmBrickAndMortarVisit'
            : 'schedulingFlow/confirmMobileVisit';
        await dispatch(confirmVisitAction);
        // Set the scheduling flow draft waypoint data locally to a state similar
        // to what will now be in the database.
        setSchedulingFlowLocalDraftWaypointFinalized();
        if (isRescheduling)
            setSchedulingFlowLocalOldDraftWaypointCanceled();
        // Set pinia denormalized draft waypoint data locally based on the
        // scheduling flow draft waypoint data for display in the visit list/page
        // while algolia updates.
        draftWaypointStore.setDraftWaypointScheduledLocally();
        if (isRescheduling) {
            const { canceledProceduresBeingRescheduled } = state;
            draftWaypointStore.setDraftWaypointCanceledLocally(undefined, undefined, canceledProceduresBeingRescheduled);
        }
        const isDryRun = isSchedulingDryRun(draftWaypoint);
        const isAppointmentOnlyVariant = getters['schedulingFlow/getIsAppointmentOnlyVariant'];
        const confirmVisitString = isAppointmentOnlyVariant
            ? 'Appointment requested'
            : 'Visit scheduled';
        const visitScheduledMessage = `${confirmVisitString}${isDryRun ? ' (dry run)' : ''}`;
        if (isNurseRescheduling) {
            toastSuccess('Job updated');
        }
        else {
            toastSuccess(visitScheduledMessage);
        }
    },
    // We will just return the first patient on the draft waypoint
    'schedulingFlow/fetchDataForPatientDOBValidation': async (_, draftWaypointID) => {
        var _a;
        const request = {
            includeBookingDataInProcedureData: true,
            includeItineraryDataInDraftWaypointData: true,
            includePatientDataInBookingData: true,
            includeProceduresDataInDraftWaypointData: true,
        };
        const draftWaypointData = await getDraftWaypointDataRequest({ draftWaypointID, request });
        const patients = getPatientsFromProceduresData((_a = draftWaypointData.proceduresData) !== null && _a !== void 0 ? _a : {});
        const patient = Object.values(patients)[0];
        if (!patient)
            throw Error('Missing patient');
        let { contact } = draftWaypointData;
        const { name, phone, userID } = contact !== null && contact !== void 0 ? contact : {};
        const isNameOrNumberMissing = !name || !phone;
        if (contact && isNameOrNumberMissing && userID) {
            const user = await getValueOnce(`${DbRef.USERS}/${userID}`);
            if (!user)
                return;
            contact = {
                ...contact,
                name: `${user.info.firstName} ${user.info.lastName}`,
                phone: user.info.phone,
            };
        }
        if (!contact)
            throw Error('Missing contact');
        if (!draftWaypointData.location)
            throw Error('Missing location');
        return {
            contact,
            location: draftWaypointData.location,
            patient,
        };
    },
    'schedulingFlow/fetchDraftWaypointData': async ({ state, commit, rootState }, draftWaypointID) => {
        var _a;
        commit('schedulingFlow/SET_IS_PATIENT_INITIATED', false);
        const request = {
            includeBookingDataInProcedureData: true,
            includeItineraryDataInDraftWaypointData: true,
            includeOfficeDataInOrderData: true,
            includeOrderDataInProcedureData: true,
            includePatientDataInBookingData: true,
            includePlaceAccountsDataInProcedureData: true,
            includePlaceGroupDataInPlaceAccountData: true,
            includePrescriberDataInOrderData: true,
            includeProceduresDataInDraftWaypointData: true,
            includeSchedulingUserDataInOrderData: true,
            includeSupplyInstructionConfigOptionsDataInProcedureData: true,
            includeSupplyTransfersDataInDraftWaypointData: true,
            includeWaypointActionsDataInWaypointData: true,
            includeWaypointDataInDraftWaypointData: true,
        };
        let draftWaypointData;
        try {
            draftWaypointData = await getDraftWaypointDataRequest({ draftWaypointID, request });
        }
        catch (error) {
            const errorMessage = getUnknownErrorMessage(error);
            toastErrorAndReport(`Error fetching Draft Waypoint: ${errorMessage}`);
            return;
        }
        const { proceduresIneligibleForRescheduling, isRescheduling, } = state.localState;
        const draftWaypoint = draftWaypointDataToUnencryptedDraftWaypoint(draftWaypointData);
        if (isRescheduling) {
            setDataForRescheduling(draftWaypoint, proceduresIneligibleForRescheduling !== null && proceduresIneligibleForRescheduling !== void 0 ? proceduresIneligibleForRescheduling : []);
        }
        else {
            commit('schedulingFlow/SET_DRAFT_WAYPOINT', draftWaypoint);
        }
        commit('schedulingFlow/SET_PATIENT_SCHEDULES', isPatientUser());
        let { proceduresData } = draftWaypointData;
        if (proceduresData && Object.keys(proceduresData).length) {
            proceduresData = getReschedulableProcedureData(proceduresData !== null && proceduresData !== void 0 ? proceduresData : {}, proceduresIneligibleForRescheduling !== null && proceduresIneligibleForRescheduling !== void 0 ? proceduresIneligibleForRescheduling : []);
            const supplyInstructionsPresent = getAreAllSupplyInstructionsPresentForDraftWaypoint(draftWaypointData);
            if (!supplyInstructionsPresent)
                throw Error('Unable to begin scheduling');
            commit('schedulingFlow/SET_BOOKINGS', proceduresDataToBookings(proceduresData));
            commit('schedulingFlow/SET_PATIENT_PAYS', getPatientPays(proceduresData));
            commit('schedulingFlow/SET_PROCEDURES', proceduresDataToProcedures(proceduresData));
            commit('schedulingFlow/SET_PATIENTS', getPatientsFromProceduresData(proceduresData));
            commit('schedulingFlow/SET_SUPPLY_INSTRUCTION_CONFIG_OPTIONS', proceduresDataToSupplyInstructionConfigOptions(proceduresData));
            if (isRescheduling) {
                const canceledProceduresBeingRescheduled = getCanceledProceduresBeingRescheduled(draftWaypoint, state.procedures);
                commit('schedulingFlow/SET_CANCELED_PROCEDURES_BEING_RESCHEDULED', canceledProceduresBeingRescheduled);
            }
            const placeGroups = {};
            const placeAccounts = {};
            Object.values(proceduresData).forEach((procedure) => {
                const { placeAccountsData, orderData } = procedure;
                Object.values(placeAccountsData !== null && placeAccountsData !== void 0 ? placeAccountsData : {}).forEach((placeAccountData) => {
                    const { placeGroupData } = placeAccountData;
                    placeAccounts[placeAccountData.id] = placeAccountData;
                    if (placeGroupData) {
                        placeGroups[placeGroupData.id] = placeGroupData;
                    }
                });
                if (orderData) {
                    commit('orders/SET_ORDERS', { [orderData.id]: orderData });
                    if (orderData.schedulingUserData) {
                        /**
                         * can't a scheduling user also be of type User?
                         */
                        commit('users/SET_STAFF_USER', orderData.schedulingUserData);
                    }
                }
            });
            commit('schedulingFlow/SET_PLACE_ACCOUNTS', placeAccounts);
            commit('schedulingFlow/SET_PLACE_GROUPS', placeGroups);
        }
        const { draftProceduresData, supplyTransfersData, waypointData, } = draftWaypointData;
        const prescriber = getPrescriberDataFromDraftWaypointData(draftWaypointData);
        if (prescriber)
            commit('schedulingFlow/SET_PRESCRIBER', prescriber);
        if (waypointData)
            commit('schedulingFlow/SET_WAYPOINT', getWaypointFromWaypointData(waypointData));
        if (supplyTransfersData)
            commit('schedulingFlow/SET_SUPPLY_TRANSFERS', supplyTransfersData);
        /** Store waypoint actions data */
        const waypointActionsData = waypointData === null || waypointData === void 0 ? void 0 : waypointData.waypointActionsData;
        if (waypointActionsData) {
            commit('schedulingFlow/SET_WAYPOINT_ACTIONS', getWaypointActionsFromWaypointActionsData(waypointActionsData));
        }
        if (draftProceduresData) {
            const patientPays = getPatientPays(draftProceduresData);
            commit('schedulingFlow/SET_PATIENT_PAYS', patientPays);
            commit('schedulingFlow/SET_DRAFT_PROCEDURES', draftProceduresData);
            commit('schedulingFlow/SET_DRAFT_BOOKINGS', proceduresDataToBookings(draftProceduresData));
            commit('schedulingFlow/SET_PATIENTS', getPatientsFromProceduresData(draftProceduresData));
            Object.values(draftProceduresData).forEach((draftProcedure) => {
                const { orderData } = draftProcedure;
                if (orderData) {
                    if (orderData) {
                        commit('orders/SET_ORDERS', {
                            [orderData.id]: orderData,
                        });
                        if (orderData.schedulingUserData) {
                            commit('users/SET_STAFF_USER', orderData.schedulingUserData);
                        }
                    }
                }
            });
            const { user } = rootState.auth;
            if ((user === null || user === void 0 ? void 0 : user.role) === Role.PATIENT) {
                trackEvent({ state: rootState }, TrackingEvent.PATIENT_SCHEDULING, {
                    draftWaypointID: draftWaypointID !== null && draftWaypointID !== void 0 ? draftWaypointID : 'Unknown',
                    officeID: (_a = getOfficeFromProceduresData(draftProceduresData)) === null || _a === void 0 ? void 0 : _a.id,
                    patientInitiated: false,
                    payor: patientPays
                        ? BillingOption.CHARGE_PATIENT
                        : BillingOption.CHARGE_OFFICE,
                });
            }
        }
    },
    'schedulingFlow/getSchedulingOptions': async ({ commit, dispatch, state, getters }) => {
        var _a, _b, _c, _d, _e;
        const { draftWaypoint } = state;
        const { oldDraftWaypoint } = state.localState;
        try {
            if (!draftWaypoint)
                throw Error('Missing draft waypoint');
            commit('schedulingFlow/SET_LOADING', {
                draftWaypointID: draftWaypoint.id,
                loadingData: {
                    isLoading: true,
                    message: 'Loading available time windows…',
                },
            });
            const isDebugMode = getIsDebugMode();
            const isRescheduling = (_a = state.localState.isRescheduling) !== null && _a !== void 0 ? _a : false;
            const response = await getSchedulingOptionsRequest({
                draftWaypoint,
                isDebugMode,
                isRescheduling,
                oldDraftWaypointID: oldDraftWaypoint === null || oldDraftWaypoint === void 0 ? void 0 : oldDraftWaypoint.id,
            });
            const { timeSlots, labOptions, schedulingConfig, schedulingFilters, staffingOfficeNames, } = response;
            commit('schedulingFlow/SET_AVAILABLE_TIME_SLOTS', timeSlots);
            commit('schedulingFlow/SET_LAB_OPTIONS', labOptions);
            commit('schedulingFlow/SET_SCHEDULING_CONFIG', schedulingConfig);
            commit('schedulingFlow/SET_SCHEDULING_FILTERS', schedulingFilters);
            commit('schedulingFlow/SET_IS_PAYMENT_DISABLED', (_c = (_b = schedulingConfig === null || schedulingConfig === void 0 ? void 0 : schedulingConfig.paymentScheduling) === null || _b === void 0 ? void 0 : _b.disablePayment) !== null && _c !== void 0 ? _c : false);
            commit('schedulingFlow/SET_TIME_SLOTS_LAST_FETCHED_AT', Date.now());
            // If the user is a superadmin, assistant, or prescriber, we need to get the staffing office info
            // that can be used to filter the staffing offices on admin mode.
            const canEnableAdmin = [
                Role.ASSISTANT,
                Role.PRESCRIBER,
                Role.SUPERADMIN,
            ].includes((_d = getUserRole()) !== null && _d !== void 0 ? _d : Role.PATIENT);
            const examOneIntegrationEnabled = getIsFulfillmentIntegrationEnabled(FulfillmentIntegrationName.EXAMONE, FulfillmentIntegrationType.MOBILE);
            if (examOneIntegrationEnabled && canEnableAdmin) {
                commit('schedulingFlow/SET_ADMIN_MODE_ALL_STAFFING_OFFICES', staffingOfficeNames);
                commit('schedulingFlow/SET_ADMIN_MODE_OFFICE_FILTERS');
                const staffingInfoByTimeSlot = getStaffingInfoPerTimeSlot(timeSlots);
                commit('schedulingFlow/SET_ADMIN_MODE_STAFFING_INFO_PER_TIME_SLOT', staffingInfoByTimeSlot);
            }
            const numberOfBrickAndMortarLabs = getters['schedulingFlow/getNumberOfBrickAndMortarLabs'];
            commit('schedulingFlow/SET_IS_BRICK_AND_MORTAR_ELIGIBLE', !!numberOfBrickAndMortarLabs);
        }
        catch (error) {
            const PROD_ERROR_MESSAGE = 'Failed to get time options';
            const DETAILED_ERROR_MESSAGE = `Failed to get scheduling options: ${getUnknownErrorMessage(error)}`;
            const errorToDisplay = isProd ? PROD_ERROR_MESSAGE : DETAILED_ERROR_MESSAGE;
            toastErrorAndReport(errorToDisplay, DETAILED_ERROR_MESSAGE);
            console.error(error);
        }
        finally {
            commit('schedulingFlow/SET_LOADING', {
                // Empty string is safe because we wouldn't have set loading state if we didn't have a draftWaypoint
                draftWaypointID: (_e = draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.id) !== null && _e !== void 0 ? _e : '',
                loadingData: { isLoading: false },
            });
            dispatch('schedulingFlow/trackSchedulingAttempt');
        }
    },
    'schedulingFlow/handlePaymentSucceeded': async ({ rootState, state }, paymentIntent) => {
        var _a;
        try {
            const userID = (_a = rootState.auth.user) === null || _a === void 0 ? void 0 : _a.id;
            if (!userID)
                throw Error('Missing user information.');
            if (!state.draftWaypoint)
                throw Error('Missing waypoint information.');
            const requestData = {
                draftWaypointID: state.draftWaypoint.id,
                paymentCategory: PaymentCategory.VISIT,
                paymentIntentID: paymentIntent.id,
            };
            const responsePaymentIntent = await handlePaymentIntentSucceededRequest(requestData);
            if (!(responsePaymentIntent === null || responsePaymentIntent === void 0 ? void 0 : responsePaymentIntent.transaction))
                throw Error('Payment transaction failed.');
        }
        catch (error) {
            reportException(error);
            toastErrorAndReport(`There was a problem scheduling the visit. ${errorSuffix}`);
        }
    },
    'schedulingFlow/initDraftWaypoint': async ({ commit, rootState }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const route = getRoute();
        const { taskTypeID } = route.value.query;
        if (!taskTypeID || typeof taskTypeID !== 'string') {
            throw new Error('Please specify a taskTypeID in the url.');
        }
        /**
         * This value is hard coded for testing purposes. The structure in the database will need to be modified
         * to match the new structure.
         */
        const templateSupplyInstructionConfig = (_a = rootState.variables.variables) === null || _a === void 0 ? void 0 : _a.templateSupplyInstructionConfig;
        if (!templateSupplyInstructionConfig) {
            throw new Error('Cannot find templateSupplyInstructionConfig');
        }
        let officeObject = (_b = rootState.offices.partnerOffice) !== null && _b !== void 0 ? _b : null;
        if (!officeObject) {
            officeObject = await getValueOnce(getOfficePath(GenericOfficeIDs.PATIENT_INITIATED));
        }
        const draftOrder = await initPatientInitiatedDraftOrder(taskTypeID, officeObject, null);
        const procedureIDs = Object.keys((_c = draftOrder.draftProcedures) !== null && _c !== void 0 ? _c : {});
        const draftWaypoint = initDraftWaypoint(procedureIDs, draftOrder.id, officeObject === null || officeObject === void 0 ? void 0 : officeObject.id);
        // Assign draftWaypoint to draftOrder
        draftOrder.draftWaypoints = update(draftOrder.draftWaypoints, {
            [draftWaypoint.id]: { $set: true },
        });
        draftOrder.draftOrder.draftWaypoints = {
            ...draftOrder.draftOrder.draftWaypoints,
            [draftWaypoint.id]: true,
        };
        customCommit(commit, 'orderFlow/INIT_RE_ORDER', draftOrder);
        commit('schedulingFlow/SET_IS_PATIENT_INITIATED', true);
        commit('schedulingFlow/SET_DRAFT_WAYPOINT', draftWaypoint);
        commit('schedulingFlow/SET_PATIENT_SCHEDULES', isPatientUser());
        /**
         * Due to the types changes there is a different data structure that requires
         * a place group ID.
         */
        const placeGroupIDs = [DUMMY_PLACE_GROUP_ID];
        const supplyInstructionsByProcedureID = keyValueArrayToObj(placeGroupIDs.map((placeGroupID) => ({
            key: placeGroupID,
            value: templateSupplyInstructionConfig,
        })));
        commit('schedulingFlow/SET_SUPPLY_INSTRUCTION_CONFIG_OPTIONS', supplyInstructionsByProcedureID);
        const patientPays = (_e = (_d = officeObject === null || officeObject === void 0 ? void 0 : officeObject.bookingPricing) === null || _d === void 0 ? void 0 : _d.paymentEnabled) !== null && _e !== void 0 ? _e : true;
        commit('schedulingFlow/SET_PATIENT_PAYS', patientPays);
        commit('schedulingFlow/SET_DRAFT_PROCEDURES', (_f = draftOrder.draftProcedures) !== null && _f !== void 0 ? _f : {});
        commit('schedulingFlow/SET_DRAFT_BOOKINGS', (_g = draftOrder.draftBookings) !== null && _g !== void 0 ? _g : {});
        const { user } = rootState.auth;
        if ((user === null || user === void 0 ? void 0 : user.role) === Role.PATIENT) {
            trackEvent({ state: rootState }, TrackingEvent.PATIENT_SCHEDULING, {
                draftWaypointID: (_h = draftWaypoint.id) !== null && _h !== void 0 ? _h : 'Unknown',
                officeID: officeObject === null || officeObject === void 0 ? void 0 : officeObject.id,
                patientInitiated: true,
                payor: patientPays
                    ? BillingOption.CHARGE_PATIENT
                    : BillingOption.CHARGE_OFFICE,
            });
        }
    },
    'schedulingFlow/initPatientInitiatedUserProfile': async ({ commit, rootState }) => {
        var _a, _b, _c, _d, _e;
        const { user } = rootState.auth;
        commit('schedulingFlow/SET_IS_PATIENT_INITIATED_USER_PROFILE', {
            dateOfBirth: (_b = (_a = user === null || user === void 0 ? void 0 : user.info) === null || _a === void 0 ? void 0 : _a.dateOfBirth) !== null && _b !== void 0 ? _b : null,
            firstName: (_c = user === null || user === void 0 ? void 0 : user.info) === null || _c === void 0 ? void 0 : _c.firstName,
            gender: (_d = user === null || user === void 0 ? void 0 : user.info) === null || _d === void 0 ? void 0 : _d.gender,
            lastName: (_e = user === null || user === void 0 ? void 0 : user.info) === null || _e === void 0 ? void 0 : _e.lastName,
        });
    },
    /**
     * Inits a Stripe PaymentIntent only for Patient payment. Might not get used
     * if office is paying.
     * TODO: Move logic from Payment.vue into here and create one PaymentIntent
     */
    'schedulingFlow/initPaymentIntent': async ({ commit, state, rootState }) => {
        var _a, _b;
        try {
            commit('schedulingFlow/RESET_PAYMENT_INTENT_INFO');
            const priceInfo = (_a = state.selectedTimeSlot) === null || _a === void 0 ? void 0 : _a.priceInfo;
            if (!priceInfo)
                throw Error('Missing price info when processing payment.');
            const idForPayment = (_b = rootState.auth.user) === null || _b === void 0 ? void 0 : _b.id;
            if (!idForPayment)
                throw Error('Missing user info when processing payment.');
            const paymentIntentRequest = {
                customerType: CustomerType.PATIENT,
                idForPayment,
                paymentCategory: PaymentCategory.VISIT,
                price: priceInfo.visitPrice,
            };
            const response = await createPaymentIntentRequest(paymentIntentRequest);
            commit('schedulingFlow/SET_PAYMENT_INTENT_INFO', response);
            commit('schedulingFlow/SET_PRICING_INFO', priceInfo);
        }
        catch (error) {
            commit('schedulingFlow/SET_PAYMENT_FORM_INIT_ERROR', true);
            toastError(error);
        }
    },
    'schedulingFlow/initSchedulingFlow': async ({ state, commit, dispatch }, { draftWaypointID, isRescheduling, patientInitiated, proceduresIneligibleForRescheduling, nurseReschedulingDetails, }) => {
        var _a;
        const promises = [];
        if (isRescheduling) {
            commit('schedulingFlow/SET_IS_RESCHEDULING', true);
            commit('schedulingFlow/SET_PROCEDURES_INELIGIBLE_FOR_RESCHEDULING', proceduresIneligibleForRescheduling);
            if (nurseReschedulingDetails) {
                commit('schedulingFlow/SET_NURSE_RESCHEDULING_DETAILS', nurseReschedulingDetails);
                promises.push(dispatch('schedulingFlow/setLocationAndDependencies', {
                    draftWaypointID,
                    location: nurseReschedulingDetails.location,
                }));
            }
        }
        commit('schedulingFlow/SET_PATIENT_SCHEDULES', isPatientUser());
        if (patientInitiated) {
            promises.push(dispatch('schedulingFlow/initDraftWaypoint'));
        }
        else {
            try {
                const routerRuntimeHelpers = getRouterRuntimeHelpers();
                await ((_a = routerRuntimeHelpers.forceAuthRestriction) === null || _a === void 0 ? void 0 : _a.call(routerRuntimeHelpers));
            }
            catch (_error) {
                throw new Error(InitSchedulingFlowErrorMessage.UNAUTHORIZED);
            }
            commit('app/SET_LOADING_IDS', {
                [SchedulingFlowRouteName.SCHEDULING_FLOW]: false,
            });
            promises.push(dispatch('schedulingFlow/fetchDraftWaypointData', draftWaypointID));
        }
        await Promise.all(promises);
        const { draftWaypoint, location } = state;
        if (!draftWaypoint)
            throw Error('Missing draft waypoint');
        /** Differs from the original draft waypoint ID if rescheduling. */
        const newDraftWaypointID = draftWaypoint.id;
        if (location) {
            dispatch('schedulingFlow/setLocationAndDependencies', { draftWaypointID: newDraftWaypointID, location });
        }
        if (hasStatus(draftWaypoint.status, DraftWaypointStatus.PENDING)) {
            commit('schedulingFlow/SET_FLOW_DATA_IS_READY', { draftWaypointID: newDraftWaypointID, ready: true });
        }
        const visitDetailsRoute = isDashboardUser()
            ? undefined
            : draftWaypointDetailsRoute({
                params: { draftWaypointID },
            });
        return { visitDetailsRoute };
    },
    'schedulingFlow/maybeRouteToExitRoute': ({ state, rootGetters, getters }) => {
        var _a;
        if (!state.draftWaypoint)
            throw Error('No draft waypoint found');
        const { id: draftWaypointID } = state.draftWaypoint;
        const { isPatientInitiated } = state;
        const exitURL = getters['schedulingFlow/getPatientInitiatedExitURL'];
        if (isPatientInitiated && exitURL) {
            return window.open(exitURL, '_self');
        }
        const exitRoute = (_a = rootGetters['schedulingFlow/getExitRoute']) === null || _a === void 0 ? void 0 : _a.call(rootGetters, {
            id: draftWaypointID,
        });
        getRouter().push(exitRoute !== null && exitRoute !== void 0 ? exitRoute : homeRoute());
    },
    'schedulingFlow/performCompletionAction': async () => {
        const route = getRoute().value;
        await getSchedulingFlowHelpers(route).performCompletionAction(route);
    },
    'schedulingFlow/savePatientInitiatedOrder': async ({ commit, state, rootState, dispatch }) => {
        var _a, _b, _c;
        if (!rootState.auth.user)
            throw Error('User needs to be logged in.');
        customCommit(commit, 'orderFlow/SET_PATIENT_ON_BOOKING', {
            bookingID: (_b = Object.keys((_a = rootState.orderFlow.draftBookings) !== null && _a !== void 0 ? _a : {})[0]) !== null && _b !== void 0 ? _b : '',
            patient: rootState.auth.user,
        });
        customCommit(commit, 'orderFlow/SET_SCHEDULING_USER_ID', (_c = rootState.auth.user) === null || _c === void 0 ? void 0 : _c.id);
        customCommit(commit, 'users/SET_USER', rootState.auth.user);
        const { draftWaypoint } = state;
        if (!draftWaypoint)
            throw Error('Draft waypoint not found');
        if (!draftWaypoint.officeID)
            throw Error('Missing officeID under draftWaypoint');
        await dispatch('offices/addPatientToOffice', {
            officeID: draftWaypoint.officeID,
            patient: rootState.auth.user,
        });
        const { draftBookings, draftOrder, draftProcedures } = rootState.orderFlow;
        if (!draftOrder)
            throw Error('Missing order');
        await saveOrderAsDraft(draftOrder, draftBookings, draftProcedures, true, false, true);
    },
    'schedulingFlow/setLocationAndDependencies': async ({ commit, rootState }, { location }) => {
        commit('schedulingFlow/SET_LOCATION', location);
        const serviceRegion = await getServiceRegionFromLocation(location, rootState.variables.variables, getValueOnce);
        if (serviceRegion) {
            commit('schedulingFlow/SET_SERVICE_REGION', serviceRegion);
        }
        const serviceRegionGroup = await getServiceRegionGroupFromLocation(location, rootState.variables.variables, getValueOnce);
        if (serviceRegionGroup) {
            commit('schedulingFlow/SET_SERVICE_REGION_GROUP', serviceRegionGroup);
        }
    },
    'schedulingFlow/trackSchedulingAttempt': async ({ state }) => {
        try {
            const { draftWaypoint, serviceRegion, location, availableTimeSlots, labOptions } = state;
            if (!draftWaypoint)
                throw Error('Missing draft waypoint');
            if (!serviceRegion)
                throw Error('Missing service region');
            if (!location)
                throw Error('Missing location');
            const { lat, lng, formattedAddress: address } = location;
            if (!lat || !lng || !address)
                throw Error('Missing location data');
            const eligibleTimeSlots = getEligibleTimeSlots(availableTimeSlots);
            const [filteredTimeSlots, filteredNurses,] = Object.entries(eligibleTimeSlots).reduce((acc, [dateString, timeSlots]) => {
                const date = parseInt(dateString, 10);
                const nurses = new Set(Object.values(timeSlots).flatMap((timeSlot) => Object.keys(timeSlot.availableNurses)));
                acc[0][date] = Object.keys(timeSlots).map(Number);
                acc[1].push(...nurses);
                return acc;
            }, [{}, []]);
            const request = {
                address,
                batchNumber: 1,
                draftWaypointID: draftWaypoint.id,
                filteredNurses,
                filteredPlaces: Object.keys(labOptions),
                filteredTimeSlots,
                lat,
                lng,
                schedulingAttemptID: generateID(),
                serviceRegionID: serviceRegion.id,
            };
            await trackSchedulingAttemptRequest(request);
        }
        catch (error) {
            console.error(error);
        }
    },
};
const schedulingFlowGetters = {
    'schedulingFlow/getAdminMode': (state) => state.adminMode,
    'schedulingFlow/getAdminModeAllStaffingOffices': (state) => state.adminModeAllStaffingOffices,
    'schedulingFlow/getAdminModeOfficeFilters': (state) => { var _a; return (_a = state.adminModeOfficeFilters) !== null && _a !== void 0 ? _a : []; },
    'schedulingFlow/getAdminModeShowAllTimeSlots': (state) => state.adminModeShowAllTimeSlots,
    'schedulingFlow/getAdminModeStaffingInfoPerTimeSlot': (state) => state.adminModeStaffingInfoPerTimeSlot,
    'schedulingFlow/getBackStepRouteInOrder': () => (route) => {
        const back = getSchedulingFlowHelpers(route).getBackOrNextStepRoute(route, 'back');
        if (!back)
            return null;
        return keepParams(keepQuery(back));
    },
    'schedulingFlow/getBackStepToVisitPage': () => (route) => {
        const back = buildMaybePartnerRouteWithCurrentRoute({ name: SchedulingFlowRouteName.SCHEDULING_FLOW_ADDRESS }, route);
        return keepParams(keepQuery(back));
    },
    /**
     * Get bookings on the draft waypoint, regardless of whether they are
     * draft or not. This relies on only the correct bookings being returned
     * by the cloud function during fetch.
     */
    'schedulingFlow/getBookings': (state) => {
        if (!state.draftWaypoint)
            return {};
        return {
            ...state.draftBookings,
            ...state.bookings,
        };
    },
    /**
     * Get bookings data with nested patient and procedure data, regardless of
     * whether they are draft or not. This relies on only the correct bookings
     * being returned by the cloud function during fetch. Procedures will only be
     * included if they are on the draft waypoint.
     */
    'schedulingFlow/getBookingsData': (state) => {
        const bookings = schedulingFlowGetters['schedulingFlow/getBookings'](state);
        const bookingsArray = Object.values(bookings);
        const draftWaypointProcedures = schedulingFlowGetters['schedulingFlow/getProcedures'](state);
        const bookingsData = bookingsArray.reduce((currentBookingsData, booking) => {
            var _a, _b, _c, _d;
            const patientData = (_b = schedulingFlowGetters['schedulingFlow/getPatientByID'](state)((_a = booking.patientID) !== null && _a !== void 0 ? _a : '')) !== null && _b !== void 0 ? _b : undefined;
            const proceduresDataArray = Object.keys((_c = booking.procedures) !== null && _c !== void 0 ? _c : {})
                .map((procedureID) => draftWaypointProcedures[procedureID])
                .filter(nullishFilter);
            const proceduresData = arrayToObj(proceduresDataArray, 'id');
            const procedures = objectFilter((_d = booking.procedures) !== null && _d !== void 0 ? _d : {}, ({ id }) => id in proceduresData);
            const bookingData = {
                ...booking,
                patientData,
                procedures,
                proceduresData,
            };
            return {
                ...currentBookingsData,
                [booking.id]: bookingData,
            };
        }, {});
        return bookingsData;
    },
    'schedulingFlow/getCurrentStep': () => (route) => getSchedulingFlowHelpers(route).getStepFromRoute(route),
    'schedulingFlow/getCurrentStepBackComponent': () => (route) => getSchedulingFlowHelpers(route).getCurrentStepBackHeaderComponent(route),
    'schedulingFlow/getCurrentStepCompletionAction': () => (route) => getSchedulingFlowHelpers(route).getCurrentStepCompletionAction(route),
    'schedulingFlow/getCurrentStepSecondaryComponent': () => (route) => getSchedulingFlowHelpers(route).getCurrentStepSecondaryHeaderComponent(route),
    'schedulingFlow/getCurrentStepTertiaryComponent': () => (route) => getSchedulingFlowHelpers(route).getCurrentStepTertiaryHeaderComponent(route),
    'schedulingFlow/getCurrentStepValidationFailures': () => (route) => getSchedulingFlowHelpers(route).getCurrentStepValidationFailures(route),
    'schedulingFlow/getFailedValidationMessage': (state, getters, rootState) => {
        if (!schedulingFlowGetters['schedulingFlow/getIsValidPrimaryContact'](state, getters, rootState))
            return 'Please add a point of contact';
        return null;
    },
    'schedulingFlow/getHasSchedulingOptions': (state) => {
        const numberOfBrickAndMortarLabs = schedulingFlowGetters['schedulingFlow/getNumberOfBrickAndMortarLabs'](state);
        const numberOfEligibleTimeSlots = schedulingFlowGetters['schedulingFlow/getNumberOfEligibleTimeSlots'](state);
        return !!numberOfBrickAndMortarLabs || !!numberOfEligibleTimeSlots;
    },
    'schedulingFlow/getIsAppointmentOnlyVariant': (state, _getters, rootState) => {
        var _a;
        if (!isPatientUser())
            return false;
        const { localState, selectedDrawPlaceID } = state;
        const { isBrickAndMortarVisit } = localState;
        const selectedPlace = selectedDrawPlaceID
            ? (_a = rootState.places.places) === null || _a === void 0 ? void 0 : _a[selectedDrawPlaceID]
            : undefined;
        return isBrickAndMortarVisit && !!(selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.appointmentOnly);
    },
    'schedulingFlow/getIsCanceledProcedureBeingRescheduled': (state) => (procedureID) => { var _a; return !((_a = state.localState.proceduresIneligibleForRescheduling) === null || _a === void 0 ? void 0 : _a.includes(procedureID)); },
    'schedulingFlow/getIsCurrentStepValid': () => (route) => computed(() => schedulingFlowGetters['schedulingFlow/getCurrentStepValidationFailures']()(route) === null),
    /** Get whether the draft waypoint was initiated via a draft order */
    'schedulingFlow/getIsDraftOrder': (state) => {
        const { draftWaypoint } = state;
        return !isNullish(draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.draftOrderID);
    },
    'schedulingFlow/getIsFastingRequired': (state) => {
        var _a;
        return Object.values((_a = state.procedures) !== null && _a !== void 0 ? _a : {})
            .some((procedure) => {
            var _a;
            return (_a = procedure.instructions) === null || _a === void 0 ? void 0 : _a.some((instr) => instr.type === InstructionType.FASTING && instr.instruction !== YesNoOptionLabel.NO);
        });
    },
    'schedulingFlow/getIsValidPrimaryContact': (state, getters, rootState) => {
        var _a, _b, _c;
        let isValid = false;
        const contact = state.primaryContact;
        if (contact) {
            if (contact.custom) {
                isValid = (!!contact.name
                    && !!((_a = contact.phone) === null || _a === void 0 ? void 0 : _a.number)
                    && !contact.userID);
            }
            else {
                isValid
                    = !!contact.userID
                        && !!schedulingFlowGetters['schedulingFlow/getPrimaryContactPhoneNumber'](state, getters, rootState)((_c = (_b = state.primaryContact) === null || _b === void 0 ? void 0 : _b.userID) !== null && _c !== void 0 ? _c : '');
            }
        }
        return isValid;
    },
    'schedulingFlow/getLabOrderID': (state) => {
        var _a;
        const procedures = Object.values(schedulingFlowGetters['schedulingFlow/getProcedures'](state));
        const procedure = procedures[0];
        return (_a = procedure === null || procedure === void 0 ? void 0 : procedure.healthGorillaInfo) === null || _a === void 0 ? void 0 : _a.resourceID;
    },
    'schedulingFlow/getLocallyFinalized': (state) => state.localState.locallyFinalized,
    'schedulingFlow/getNextStepRouteInOrder': () => (route) => {
        const next = getSchedulingFlowHelpers(route).getBackOrNextStepRoute(route, 'next');
        if (!next)
            return null;
        return keepParams(keepQuery(next));
    },
    'schedulingFlow/getNumberOfBrickAndMortarLabs': (state) => Object.values(state.labOptions).length,
    'schedulingFlow/getNumberOfEligibleTimeSlots': (state) => {
        const eligibleTimeSlots = getEligibleTimeSlots(state.availableTimeSlots);
        return Object.values(eligibleTimeSlots).flatMap((timeSlotsByStartTime) => Object.values(timeSlotsByStartTime)).length;
    },
    /**
     * Get a patient on the draft waypoint, regardless of whether they are
     * draft or not.
     */
    'schedulingFlow/getPatientByID': (state) => (id) => { var _a; return (_a = schedulingFlowGetters['schedulingFlow/getPatients'](state)[id]) !== null && _a !== void 0 ? _a : null; },
    'schedulingFlow/getPatientInitiatedExitURL': (_state, _getters, rootState) => { var _a, _b, _c; return (_c = (_b = (_a = rootState.variables.variables) === null || _a === void 0 ? void 0 : _a.dynamicCopy) === null || _b === void 0 ? void 0 : _b.schedulingFlow) === null || _c === void 0 ? void 0 : _c.patientInitiated.flowExitURL; },
    /**
     * Get patients on the draft waypoint, regardless of whether they are
     * draft or not. This relies on only the correct patients being returned
     * by the cloud function during fetch.
     */
    'schedulingFlow/getPatients': (state) => {
        if (!state.draftWaypoint)
            return {};
        return state.patients;
    },
    'schedulingFlow/getPhoneNumber': (state, _getters, rootState) => {
        const procedures = schedulingFlowGetters['schedulingFlow/getProcedures'](state);
        const products = Object.values(procedures).flatMap((proc) => {
            var _a;
            return Object.values((_a = proc.products) !== null && _a !== void 0 ? _a : {}).map((elementTimestamp) => { var _a, _b; return (_b = (_a = rootState.variables.variables) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b[elementTimestamp.id]; });
        }).filter(nullishFilter);
        /**
         * A better solution would be to use database variables where Product
         * can add more products as needed
         *
         * However Toby has made it clear that this is a static change for now and
         * there is no potential to add more products to this in the future
         */
        const cancerguardProductIsSelected = products.some((product) => cancerguardSupportedProducts.includes(product.id));
        /**
         * If Cancerguard as a product is selected, the order is supported by a
         * different EXAS team
         */
        if (cancerguardProductIsSelected)
            return CANCERGUARD_SUPPORT_PHONE_NUMBER;
        return EXAS_SUPPORT_PHONE_NUMBER;
    },
    'schedulingFlow/getPrimaryContactPhoneNumber': (state, getters, rootState) => (userID) => {
        var _a;
        return (_a = schedulingFlowGetters['schedulingFlow/getPrimaryContactUser'](state, getters, rootState)(userID)) === null || _a === void 0 ? void 0 : _a.info.phone;
    },
    'schedulingFlow/getPrimaryContactUser': (state, _getters, rootState) => (userID) => {
        var _a, _b;
        if (!userID)
            return;
        return userID === ((_a = rootState.auth.user) === null || _a === void 0 ? void 0 : _a.id) ? rootState.auth.user
            : (_b = rootState.users.staffUsers[userID !== null && userID !== void 0 ? userID : '']) !== null && _b !== void 0 ? _b : state.patients[userID !== null && userID !== void 0 ? userID : ''];
    },
    /**
     * Get procedures on the draft waypoint, regardless of whether they are
     * draft or not. Only procedures listed on the draft waypoint are included.
     */
    'schedulingFlow/getProcedures': (state) => {
        if (!state.draftWaypoint)
            return {};
        const procedureIDs = Object.keys(state.draftWaypoint.procedures);
        const procedures = procedureIDs.reduce((currentProcedures, procedureID) => {
            var _a;
            const procedure = (_a = state.procedures[procedureID]) !== null && _a !== void 0 ? _a : state.draftProcedures[procedureID];
            if (!procedure) {
                toastErrorAndReport(`Procedure ${procedureID} not found`);
                return currentProcedures;
            }
            return {
                ...currentProcedures,
                [procedureID]: procedure,
            };
        }, {});
        return procedures;
    },
    'schedulingFlow/getSchedulingUserID': (state, _getters, rootState) => {
        var _a, _b, _c;
        const { draftWaypoint } = state;
        if (!draftWaypoint) {
            throw Error('Draft waypoint not found when getting scheduling user ID');
        }
        const firstBooking = Object.values((_a = state.bookings) !== null && _a !== void 0 ? _a : {})[0];
        const order = rootState.orders.orders[(_b = firstBooking === null || firstBooking === void 0 ? void 0 : firstBooking.orderID) !== null && _b !== void 0 ? _b : ''];
        return (_c = order === null || order === void 0 ? void 0 : order.schedulingUserID) !== null && _c !== void 0 ? _c : null;
    },
    'schedulingFlow/getTimeSlot': (state) => (date, startTime) => { var _a, _b; return (_b = (_a = state.availableTimeSlots) === null || _a === void 0 ? void 0 : _a[date]) === null || _b === void 0 ? void 0 : _b[startTime]; },
    'schedulingFlow/getTimeZoneOfDraftWaypointLocation': (state) => {
        var _a;
        const draftWaypointLocation = (_a = state.draftWaypoint) === null || _a === void 0 ? void 0 : _a.location;
        return draftWaypointLocation === null || draftWaypointLocation === void 0 ? void 0 : draftWaypointLocation.timeZone;
    },
};
const getSchedulingFlowModule = () => ({
    actions: schedulingFlowActions,
    getters: schedulingFlowGetters,
    mutations: schedulingFlowMutations,
    state: schedulingFlowState,
});
const initSchedulingFlowModule = (moduleExtensions) => initExtendedModule(getSchedulingFlowModule(), moduleExtensions);

export { getSchedulingFlowModule, initSchedulingFlowModule };
